import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

// 导入语言包
import zhCN from './locales/zh-CN'
import zhTW from './locales/zh-TW'
import en from './locales/en'
import ru from './locales/ru'

const i18n = new VueI18n({
  locale: localStorage.getItem('locale') || 'zh-CN', // 默认语言
  fallbackLocale: 'zh-CN', // 回退语言
  messages: {
    'zh-CN': zhCN,
    'zh-TW': zhTW,
    'en': en,
    'ru': ru
  },
  silentTranslationWarn: process.env.NODE_ENV === 'production',
  missing: function (locale, key) {
    if (process.env.NODE_ENV === 'development') {
      console.warn(`[i18n] Missing translation for key: ${key} in locale: ${locale}`)
    }
    return key
  }
})

export default i18n
